
export const montessori = {
  title: "Educación Montessori",
  bookVisit: "Reserva una visita",
  intro: {
    description: "Nuestro enfoque se inspira en la metodología Montessori, combinada con una visión educativa propia que integra naturaleza, trilingüismo y acompañamiento respetuoso. En Gándara International School, creemos en la filosofía Montessori como base de nuestro proyecto educativo. Este enfoque pedagógico, desarrollado por la Dra. Maria Montessori hace más de un siglo, sigue siendo revolucionario en su comprensión del desarrollo infantil y su respeto por cada niño como individuo único."
  },
  principles: {
    environment: {
      title: "Entorno Preparado",
      description: "Creamos espacios cuidadosamente diseñados que invitan a la exploración y el aprendizaje autodirigido, con materiales adaptados a cada etapa de desarrollo."
    },
    accompaniment: {
      title: "Acompañamiento Respetuoso",
      description: "Nuestros guías Montessori observan y acompañan el proceso natural de aprendizaje de cada niño, ofreciendo apoyo cuando es necesario mientras respetamos su autonomía."
    },
    learning: {
      title: "Aprendizaje Activo",
      description: "Los niños construyen su conocimiento a través de la manipulación, experimentación y descubrimiento, desarrollando una comprensión profunda de los conceptos."
    },
    nature: {
      title: "Conexión con la Naturaleza",
      description: "Fomentamos el contacto directo con el entorno natural como fuente de aprendizaje, bienestar y desarrollo de la conciencia ecológica."
    },
    autonomy: {
      title: "Desarrollo de la Autonomía",
      description: "Cultivamos la independencia y la capacidad de tomar decisiones, permitiendo a los niños ser protagonistas de su propio aprendizaje."
    },
    coexistence: {
      title: "Comunidad y Convivencia",
      description: "Promovemos relaciones basadas en el respeto mutuo, la colaboración y la resolución pacífica de conflictos dentro de nuestra comunidad de aprendizaje."
    }
  },
  space: {
    title: "Nuestro Espacio",
    description1: "Gándara se encuentra en un entorno privilegiado que combina naturaleza y proximidad al centro urbano de Vigo.",
    description2: "Nuestras instalaciones están diseñadas específicamente para facilitar el aprendizaje Montessori, con espacios luminosos, ordenados y adaptados a las necesidades de los niños.",
    description3: "Cada aula es un ambiente preparado donde los materiales están organizados de manera lógica y accesible, invitando a la actividad autónoma y al descubrimiento.",
    property: "Finca de más de 5.000 m² con amplias zonas verdes, huerto escolar y áreas de juego al aire libre",
    facilities: "Espacios interiores acogedores con materiales Montessori de alta calidad",
    location: "Ubicación estratégica: a 10 minutos del centro de Vigo y con fácil acceso desde la AP-9"
  },
  classrooms: {
    title: "Aulas Montessori",
    description: "Nuestros ambientes preparados están diseñados para fomentar la autonomía, la exploración y el aprendizaje activo en cada etapa del desarrollo."
  },
  infantil: {
    title: "Educación Infantil (3-6 años)",
    description: "En la etapa de infantil, los niños y niñas trabajan en un ambiente preparado con materiales Montessori que invitan a la exploración sensorial, el desarrollo del lenguaje y las primeras nociones matemáticas.",
    classroom: "El aula de infantil es un espacio luminoso y ordenado donde cada material tiene su lugar. Los niños eligen libremente sus actividades y trabajan a su ritmo, acompañados por guías formados en metodología Montessori."
  },
  primary: {
    title: "Educación Primaria (6-12 años)",
    description: "La etapa de primaria se divide en dos ciclos: Taller 1 (6-9 años) y Taller 2 (9-12 años). Los niños trabajan en proyectos interdisciplinares que conectan áreas de conocimiento y fomentan la investigación.",
    classroom: "En primaria, el aprendizaje se extiende más allá del aula. Los proyectos de investigación, las salidas al entorno natural y el trabajo cooperativo son la base de nuestra propuesta educativa."
  },
  nature: {
    title: "Naturaleza y Aprendizaje Activo",
    description: "En Gándara, la naturaleza no es solo un entorno: es una herramienta pedagógica. Nuestros más de 5.000 m² de finca ofrecen huerto, jardín y espacios verdes donde los niños aprenden ciencias naturales de forma vivencial, desarrollan la motricidad y conectan con los ciclos de la vida."
  }
};
